module.exports = __webpack_public_path__ + "img/Guirlande_tassel.d03a961.jpg";